import { useContext, useEffect } from 'react';

// firebase
import firebase from 'firebase/app';
import 'firebase/auth';

// store
import { StoreContext } from '../../store/StoreProvider';
import act from '../../store/actions';

// commons code
import { getFormatUser } from '../../commons/utils';

const AuthListener = () => {
	// eslint-disable-next-line no-unused-vars
	const [_, dispatch] = useContext(StoreContext);

	useEffect(() => {
		firebase.auth().onAuthStateChanged((user) => {
			if (user) {
				const userInfo = getFormatUser(user);
				const { uid, displayName, email } = userInfo;
				if (uid && (displayName || email)) {
					dispatch({
						type: act.FIREBASE_LOGIN_USER,
						payload: userInfo,
					});
				}
				// localStorage
				localStorage.setItem('isLogin', JSON.stringify(true));
			} else {
				// localStorage
				localStorage.removeItem('isLogin');
			}
		});
	}, [dispatch]);

	return null;
};

export default AuthListener;
